import { useFanforgeApi } from '@hotpot-arcade/fanforge-api-client';
import { useParams } from 'react-router-dom';
import { useEffect, useRef } from 'react';

export const AlertOverlayTest = () => {
  const apiClient = useFanforgeApi();
  const { partnerId } = useParams();
  const hasCalledRef = useRef(false);

  useEffect(() => {
    if (hasCalledRef.current || !partnerId) return;
    hasCalledRef.current = true;

    apiClient.client.overlay[':creatorId'].test.$get({ param: { creatorId: partnerId } });
  }, [apiClient, partnerId]);

  return <div>Test Overlay</div>;
};
